const RECIPE_SORT_STRATEGIES = {
  title_asc: { column: 'title', ascending: true },
  title_desc: { column: 'title', ascending: false },
  created_at_asc: { column: 'created_at', ascending: true },
  created_at_desc: { column: 'created_at', ascending: false },
} as const;

export type RecipeSortKey = keyof typeof RECIPE_SORT_STRATEGIES;

const DEFAULT_RECIPE_SORT_KEY: RecipeSortKey = 'created_at_desc';
const resolveRecipeSortStrategy = (sortKey: string) =>
  RECIPE_SORT_STRATEGIES[sortKey as RecipeSortKey] ?? RECIPE_SORT_STRATEGIES[DEFAULT_RECIPE_SORT_KEY];

export const applyRecipeSort = <T extends { order: (column: string, options: { ascending: boolean }) => T }>(
  query: T,
  sortKey: string
): T => {
  const strategy = resolveRecipeSortStrategy(sortKey);

  return query.order(strategy.column, { ascending: strategy.ascending });
};
